'use client';

import { useId } from 'react';
import clsx from 'clsx';

import { Stack } from '../layout';
import { Text } from '../text';
import classes from './loader.module.css';

interface LoaderProps {
  className?: string;
  title?: string;
  description?: string;
  size?: number;
}

const DEFAULT_SIZE = 40;

export const Loader = ({ className, title, description, size, ...rest }: LoaderProps) => {
  const titleId = useId();
  const descriptionId = useId();

  return (
    <Stack align="center" gap={0}>
      <Stack
        align="center"
        justify="center"
        gap={0}
        style={size ? { width: size, height: size } : undefined}
      >
        <div
          role="progressbar"
          className={clsx(classes.loader, className)}
          style={
            size
              ? {
                  transform: `scale(${size / DEFAULT_SIZE})`,
                }
              : undefined
          }
          aria-labelledby={title ? titleId : undefined}
          aria-describedby={description ? descriptionId : undefined}
          {...rest}
        >
          <span />
          <span />
        </div>
      </Stack>
      {title && (
        <Text id={titleId} mt="lg">
          {title}
        </Text>
      )}
      {description && (
        <Text size="sm" c="dimmed" id={descriptionId}>
          {description}
        </Text>
      )}
    </Stack>
  );
};
